const EMAIL_REGEX = /^[a-zA-Z0-9_%+-](?:\.?[a-zA-Z0-9_%+-])*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;

const EXPORT_FILE_NAME_PATTERN = new RegExp('^[^\\0\\x01-\\x1f\\\\/:*?"<>|]+$');

const EXPORT_FILE_NAME_MAX_LENGTH = 100;

/**
 * User-facing error for a value that isn't a valid email. Shared so the backend
 * DTO (`@IsEmail` message) and the client-side pre-check show the same wording.
 */
export const EMAIL_ERROR = 'Enter a valid email address.';

export function isValidEmail(email: string): boolean {
  const trimmed = email.trim();
  const atIndex = trimmed.indexOf('@');
  if (atIndex > 64) return false;
  if (trimmed.length - atIndex - 1 > 253) return false;
  return EMAIL_REGEX.test(trimmed);
}

export function isValidFileName(name: string): boolean {
  const trimmed = name.trim();
  return (
    trimmed.length > 0 &&
    trimmed.length <= EXPORT_FILE_NAME_MAX_LENGTH &&
    EXPORT_FILE_NAME_PATTERN.test(trimmed)
  );
}

export function parseAndDeduplicateEmails(
  raw: string,
  separator = '\n'
): string[] {
  if (!raw?.trim()) {
    return [];
  }
  const seen = new Set<string>();
  return raw
    .split(separator)
    .map((entry) => entry.trim())
    .filter((entry) => {
      if (!entry.length) return false;
      const lower = entry.toLowerCase();
      if (seen.has(lower)) return false;
      seen.add(lower);
      return true;
    });
}
